import TransWithFallback from '../../../../../../shared/components/Translations/TransWrapper';
import AutoTextfit from '../../../../../../shared/components/AutoTextfit';

import styles from '../JackpotBottomBand/JackpotBottomBand.module.css';
import { useViewMode } from 'store/app/appStore';

const CrashGameLabel = () => {
  const viewMode = useViewMode();
  
  return (
    <div data-view={viewMode} className={`${styles.jackpotBand} ${styles.jackpotGameLabelCrashGame} `}>
      <AutoTextfit maxFontSize={34} minFontSize={7}>
        <TransWithFallback i18nKey="CRASH_GAME" />
      </AutoTextfit>
    </div>
  );
};

export default CrashGameLabel;
